// Formatowanie polskich numerow telefonu do wyswietlenia.
// Nie zmienia danych w bazie - tylko reformatuje cyfry przy renderze.
// Obsluguje wiele numerow rozdzielonych ';' lub ','.

const formatDigits = (digits: string): string =>
  digits.replace(/(\d{3})(?=\d)/g, "$1 ");

const formatSingle = (raw: string): string => {
  const trimmed = raw.trim();
  if (!trimmed) return raw;
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");

  // PL z prefiksem 48 (np. +48 608 709 608 lub 48608709608)
  if (digits.length === 11 && digits.startsWith("48")) {
    return `+48 ${formatDigits(digits.slice(2))}`;
  }
  // 9 cyfr - standardowy polski numer
  if (digits.length === 9 && !hasPlus) {
    return formatDigits(digits);
  }
  // Inne (zagraniczne, nietypowe) - zwracamy oryginal
  return trimmed;
};

export const formatPhoneDisplay = (raw: string | null | undefined): string => {
  if (!raw) return "";
  // Wiele numerow rozdzielonych ';' lub ',' - formatuj kazdy osobno
  if (/[;,]/.test(raw)) {
    return raw
      .split(/[;,]/)
      .map((part) => formatSingle(part))
      .filter(Boolean)
      .join(", ");
  }
  return formatSingle(raw);
};
